<template>
  <div class="realEstatePanel">
    <div class="mt-2">
      <!-- Header -->
      <div class="d-flex">
        <feather-icon icon="SendIcon" size="19" />
        <h4 class="mb-0 ml-50">
          {{ msg('New Guideline') }}
        </h4>
      </div>
      <!-- Save Button -->
      <div v-if="guideline.buid" class="text-right mt-2">
        <b-button variant="outline-primary" @click="createGuideline">
          {{ msg('Save') }}
        </b-button>
      </div>
      <!-- Guideline Info -->
      <b-row class="mt-1">
        <b-col cols="6">
          <b-form-group :label="msg('Alias')">
            <b-form-input v-model="guideline.alias" />
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group :label="msg('Branch')">
            <v-select
                v-model="guideline.buid"
                :options="allBranches"
                class="w-100"
                label="name"
                :reduce="(branch) => branch.id"
                :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="12" lg="12">
          <b-form-group :label="msg('Real estate')" label-for="realEstate-name">
            <real-estate-picker multiple v-model="guideline.propertyIds"/>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Checklist Sections -->
      <!-- Accordion Wrapper -->
      <b-card no-body class="mb-2" v-for="(label, field) in checklistFields" :key="field">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
              v-b-toggle="'accordion-' + field"
              class="text-center w-100"
          >
            <strong>
              {{ msg(label) }} <span v-if="guideline[field]!=null">({{ guideline[field].length }})</span>
            </strong>
          </b-button>
        </b-card-header>

        <b-collapse :id="'accordion-' + field" accordion="guideline-accordion" role="tabpanel">
          <b-card-body>
            <div
                v-for="(item, index) in guideline[field]"
                :key="index"
                class="mb-2 border p-2 rounded"
            >
              <!-- Image Preview -->
              <div v-if="item.base64Image" class="mb-1">
                <img
                    :src="item.base64Image"
                    alt="preview"
                    style="max-width: 200px; max-height: 200px;"
                />
              </div>

              <!-- Upload -->
              <b-form-group :label="msg('Upload Image')">
                <b-form-file @change="onImageChange($event, field, index)" />
              </b-form-group>

              <!-- Description -->
              <b-form-group :label="msg('Description')">
                <b-form-input v-model="item.description" />
              </b-form-group>

              <!-- Remove -->
              <b-button variant="danger" size="sm" @click="removeImage(field, index)">
                {{ msg('Remove') }}
              </b-button>
            </div>

            <!-- Add New -->
            <b-button variant="outline-primary" size="sm" @click="addImage(field)">
              + {{ msg('Add Image') }}
            </b-button>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Save Button -->
      <div v-if="guideline.buid" class="text-right mt-2">
        <b-button variant="outline-primary" @click="createGuideline">
          {{ msg('Save') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RealEstatePicker from "@/components/components/picker/realEstatesPicker.vue";

export default {
  name: 'createGuidelinePanel',
  components: {RealEstatePicker},
  data() {
    return {
      guideline: {
        alias: '',
        buid: null
        // category fields will be initialized in created()
      },
      checklistFields: {
        houseRules: 'House Rules',
        internet: 'Internet',
        electricity: 'Electricity',
        gas: 'Gas',
        tv: 'TV',
        washingMachine: 'Washing Machine',
        heaterAndHotWater: 'Heater & Hot Water',
        locationDirections: 'Location & Directions',
        restaurants: 'Restaurants',
        shopping: 'Shopping',
        parking: 'Parking',
        luggage: 'Luggage',
        emergency: 'Emergency',
        smoking: 'Smoking',
        taxiAndTransport: 'Taxi & Transport',
        checkIn: 'Check-In',
        checkOut: 'Check-Out',
        nightlife: 'Nightlife',
        airConditioning: 'Air Conditioning',
        safeStorage: 'Safe Storage'
      }
    }
  },

  computed: {
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    }
  },

  created() {
    // Initialize empty arrays for each checklist category
    Object.keys(this.checklistFields).forEach(field => {
      this.$set(this.guideline, field, [])
    })
  },

  methods: {
    ...mapActions('guideline', ['addGuideline']),
    msg(text) {
      return text
    },

    createGuideline() {
      this.addGuideline({ guideline: this.guideline })
          .then((id) => {
            this.$emit('submitted', { status: true, server: id, id })
          })
          .catch((err) => {
            this.$emit('submitted', { status: false, server: err })
          })
    },

    addImage(field) {
      if (!Array.isArray(this.guideline[field])) {
        this.$set(this.guideline, field, [])
      }
      this.guideline[field].push({ base64Image: '', description: '' })
    },

    removeImage(field, index) {
      this.guideline[field].splice(index, 1)
    },

    onImageChange(event, field, index) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = () => {
          this.guideline[field][index].base64Image = reader.result
        }
        reader.readAsDataURL(file)
      }
    }
  }
}
</script>

<style scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
